module.exports = __webpack_public_path__ + "img/folder.5d59acc9.svg";